import { ColumnDef } from '@tanstack/react-table'
import { Item } from '~/shared/api'
import { SiteSalesTooltipValue } from '../ui/site-sales-tooltip-value'
import { ArrowToDownProduct } from '../ui/sub-content-product-2'
import type { ItemsTableTotals } from '../lib/calculate-items-table-totals.types'

const getMonthSalesTotal = (
  item: Pick<
    Item,
    'soldLastMonthCount' | 'fboLastMonthCount' | 'wbSaleLastMonthCount'
  >,
) =>
  item.soldLastMonthCount + item.fboLastMonthCount + item.wbSaleLastMonthCount

export const getItemsTableConfig = (
  totals?: ItemsTableTotals,
): ColumnDef<Item>[] => [
  {
    header: 'name',
    accessorKey: 'name',

    cell: (row) => {
      const { original } = row.cell.row

      return <ArrowToDownProduct originalData={original} />
    },
    footer: () => (totals ? <span>Итого</span> : null),
    maxSize: 200,
  },
  {
    header: 'inStock',
    accessorKey: 'inStock',
    cell: (row) => {
      const { original } = row.cell.row

      return <div>{original.count}</div>
    },
    footer: () => totals?.count ?? null,
    maxSize: 50,
  },
  {
    header: 'InTheOrder',
    accessorKey: 'InTheOrder',
    cell: (row) => {
      const { original } = row.cell.row
      return <div>{original.countInOrders}</div>
    },
    footer: () => totals?.countInOrders ?? null,
    maxSize: 50,
  },
  {
    header: 'IsRequired',
    accessorKey: 'IsRequired',
    cell: (row) => {
      const { original } = row.cell.row
      return <div>{original.countInDemands}</div>
    },
    footer: () => totals?.countInDemands ?? null,
    maxSize: 50,
  },
  {
    header: 'Stock Ozon',
    accessorKey: 'Stock Ozon',
    cell: (row) => {
      const { original } = row.cell.row
      return <div>{original.countOzon}</div>
    },
    footer: () => totals?.countOzon ?? null,
    maxSize: 50,
  },
  {
    header: 'Stock WB',
    accessorKey: 'Stock WB',
    cell: (row) => {
      const { original } = row.cell.row
      return <div>{original.countWB}</div>
    },
    footer: () => totals?.countWB ?? null,
    maxSize: 50,
  },
  {
    header: 'products:sales',
    accessorKey: 'products:sales',
    cell: (row) => {
      const { original } = row.cell.row
      return (
        <SiteSalesTooltipValue
          value={original.soldLastMonthCount}
          sources={original.soldLastMonthSources}
        />
      )
    },
    footer: () =>
      totals ? (
        <SiteSalesTooltipValue
          value={totals.soldLastMonthCount}
          sources={totals.soldLastMonthSources}
        />
      ) : null,
    maxSize: 50,
  },
  {
    header: 'FBO',
    accessorKey: 'FBO',
    cell: (row) => {
      const { original } = row.cell.row
      return <div>{original.fboLastMonthCount}</div>
    },
    footer: () => totals?.fboLastMonthCount ?? null,
    maxSize: 50,
  },
  {
    header: 'FBW',
    accessorKey: 'FBW',
    cell: (row) => {
      const { original } = row.cell.row
      return <div>{original.wbSaleLastMonthCount}</div>
    },
    footer: () => totals?.wbSaleLastMonthCount ?? null,
    maxSize: 50,
  },
  {
    header: 'Общие',
    accessorKey: 'Общие',
    cell: (row) => {
      const { original } = row.cell.row
      return (
        <div>
          <b>{getMonthSalesTotal(original)}</b>
        </div>
      )
    },
    footer: () =>
      totals ? (
        <div>
          <b>{getMonthSalesTotal(totals)}</b>
        </div>
      ) : null,
    maxSize: 50,
  },
]
